export default __webpack_public_path__ + "static/media/nvidia-aws-ami.220d6022.png";